import { Accordion, Container, Link, Message, Stack, Text } from "basis";
import { formatDate } from "library/utils";
import { CreditCard } from "../CreditCard/CreditCard";
import { Separator } from "../Separator/Separator";
import { ProofOfIncomeDocuments } from "./ProofOfIncomeDocuments";
import { ScreenProps } from "./types";

export const ProofOfIncome = ({
  state: {
    accountInfo,
    bankConnectUrl,
    employmentDetails,
    expiryDate,
    latitudePoiUrl,
    // cancelUrl,
  },
}: // dispatch,
ScreenProps) => (
  // const [modalIsOpen, setModalIsOpen] = useState(false);
  // const finalCancelMutation = useMutation((url: string) =>
  //   deleteHref<FinalCancelCliResponse>(url),
  // );
  <Stack gap="8">
    <Container bg="grey.t05" padding="4">
      <CreditCard
        cardName={accountInfo.cardName}
        cardEndsWith={accountInfo.cardEndsWith}
      />
    </Container>
    <Text as="h4" textStyle="heading4">
      Nearly there!
    </Text>
    <Separator />
    <Text>
      <strong>
        Please provide a proof of your income by {formatDate(expiryDate)}.
      </strong>
    </Text>
    <Text>
      You have a couple of options to verify your income. If you use Online Bank
      Connect, we could give you a decision now. If you upload documents, we’ll
      need 2 business days to review them.
    </Text>
    <Separator />
    <Container hasBorder padding="4">
      <Stack gap="6">
        <Text textStyle="heading5" color="primary.blue.t100">
          Option 1: Online Bank Connect
        </Text>
        <Text>
          Safe and secure online access to your bank statements for a fast,
          one-time-only verification.
        </Text>
        <Text>
          We’ve partnered with an Australian company, Illion Bank statements,
          who can help you provide us with an online copy of your bank
          statements. It’s safe and secure, we only access the info once and
          your login details are never stored.
        </Text>
        <Message severity="info-or-minor" bg="secondary.lightBlue.t25">
          We’ve sent you an SMS and an email with a link to access the Online
          Bank Connect portal. You can access Bank Connect later or click the
          button below.
          <br />
          You will be redirected to Bank Connect where you will connect with
          your bank to provide proof of income. We will communicate the decision
          with you via SMS/email which can take up to 2 business days.
        </Message>
        <Link
          appearance="primary-button"
          variant="blue-button"
          width="240"
          href={bankConnectUrl}
          newTab
        >
          Open bank connect
        </Link>
      </Stack>
    </Container>
    <Container hasBorder padding="4">
      <Stack gap="6">
        <Text textStyle="heading5" color="primary.blue.t100">
          Option 2: Upload documents
        </Text>
        <Text>Manually upload your proof of income documents.</Text>
        <Stack gap="2">
          <Link
            appearance="primary-button"
            variant="blue-button"
            width="240"
            href={latitudePoiUrl}
            newTab
          >
            Open document upload
          </Link>
          <Text textStyle="body2">
            Files can be PDFs, photographs or scanned formats.{" "}
          </Text>
        </Stack>
        <Accordion>
          <Accordion.Item>
            <Accordion.Item.Header>
              What documents do I need?
            </Accordion.Item.Header>
            <Accordion.Item.Content>
              <ProofOfIncomeDocuments
                employmentStatus={employmentDetails.employmentStatus}
              />
            </Accordion.Item.Content>
          </Accordion.Item>
        </Accordion>
        <Message severity="info-or-minor" bg="secondary.lightBlue.t25">
          We'll send you an SMS to confirm receipt.
          <br />
          You will be redirected to a screen where you can upload your documents
          to provide proof of income. We will communicate the decision with you
          via SMS/email which can take up to 2 business days
        </Message>
      </Stack>
    </Container>
    {/* <CancelLink onClick={() => setModalIsOpen(true)} />
      <Cancel
        loading={finalCancelMutation.isLoading}
        isOpen={modalIsOpen}
        onClose={() => setModalIsOpen(false)}
        onConfirm={() => {
          finalCancelMutation.mutate(cancelUrl as string, {
            onSuccess() {
              dispatch({ type: ActionType.FINAL_CANCEL });
            },
            onError() {
              dispatch({ type: ActionType.FINAL_CANCEL_FAILED });
            },
          });
        }}
      /> */}
  </Stack>
);
